<section class="reviews no-padding">
    <div class="container no-padding">
    <!-- Rating and Comments Title Div -->
    <div class="row">
        <div class="col-md-4 no-padding">
            <div class="rating-title">Ratings ({{ totalRatingSum }})</div>
        </div>
        <div class="col-md-5" style="margin-left: -2px;">
            <div class="rating-title no-padding">Comments ({{ commentListCount }})</div>
            <div class="seemore" *ngIf="commentListCount > 2">
                <i class="bi bi-stickies"></i>
                <a (click)="seeMoreValue = !seeMoreValue"
                    class="showmore"
                    role="button"
                    >See {{ seeMoreValue ? 'less' : 'more' }}
                </a>
            </div>
        </div>
    </div>

<!-- Progress Bar and Comments Scroll Div -->
    <div class="row">
        <div class="col-md-4 no-padding">
            <!-- No Rating List Starts -->
            <div class="no-review" *ngIf="totalRatingSum == 0">
                <p class="rating-title">
                    No Rating on this Asset yet. <br>
                    Be the First One to Rate
                </p>
            </div>
            <!-- No Rating List Ends -->
            <div class="star-section" *ngIf="totalRatingSum > 0">
                <span [title]="'Average Rating: ' + avg_rating">
                    <span *ngFor="let in of filledRatingStars">
                        <span class="fa fa-star star-icon filled-star-color"></span>
                    </span>
        
                    <span *ngFor="let in of unfilledRatingStars">
                        <span class="fa fa-star-o star-icon unfilled-star-color"></span>
                    </span>
                </span>
                <div class="avg-rating-count">{{avg_rating}} out of 5</div>
            </div>
            <div class="progress-rating col-md-12">
                <div class="progress-section" *ngIf="totalRatingSum > 0">
                    <div class="five-star-rating" *ngFor="let ratings of ratingList">
                        <div class="rating-number no-padding col-md-3">{{ratings.StarCount}} star</div>
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" [ngStyle]="{width: ratings.Percentage + '%'}">
                            </div>
                        </div>
                        <div class="rating-count col-md-4">{{ratings.RatingCount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-5">
            <!-- No Comments List Starts-->
            <div class="no-comments" *ngIf="commentListCount == 0">
                <p class="rating-title">
                No Comments on this Asset yet. <br>
                Be the First One to Comment.
                </p>
            </div>
            <!-- No Comments List Ends -->
            <!-- Recent two Comment List Starts  -->
            <div class="comments-list" *ngIf="!seeMoreValue && commentListCount > 0">
                <div class="commentator-padding row" *ngIf="commentList[0]">
                    <div class="profilename col-md-10">
                        {{commentList[0].Name}}
                    </div>
                </div>
                <div class="comment-description no-padding" *ngIf="commentList[0]">
                    <span class="comment" title={{commentList[0].Comments}}>
                        {{commentList[0].Comments}}
                    </span>
                </div>
                <div class="commentator-padding row" *ngIf="commentList[1]">
                    <div class="profilename col-md-10">
                        {{commentList[1].Name}}
                    </div>
                </div>
                <div class="comment-description no-padding" *ngIf="commentList[1]">
                    <span class="comment" title={{commentList[1].Comments}}>
                        {{commentList[1].Comments}}
                    </span>
                </div>
            </div>
            <!-- Recent two Comment List Ends  -->
            <!-- Expanded Comment List Showing All Comments -->
            <div class="expanded-comments-list" *ngIf="seeMoreValue && commentListCount > 0">
                <div class="row" *ngFor="let comment of commentList">
                    <div class="commentator-padding row">
                        <div class="profilename col-md-10">
                            {{comment.Name}}
                        </div>
                    </div>
                    <div class="comment-description no-padding">
                        <span class="comment" title={{comment.Comments}}>
                            {{comment.Comments}}
                        </span>
                    </div>
                </div>
            </div>
            <!-- Expanded Comment List Ends -->
        </div>
    </div>

    <!-- Rating and Comments Submit Buttons -->
    <div class="row">
        <div class="col-md-4 no-padding">
            <div class="comment-button">
                <button id="myButton" type="button" data-toggle="modal" data-target="#myModal" class="trigger-button uil-btn-secondary uil-fullwidth">
                    <span>Rate this Asset</span>
                </button>  
            </div>
        </div>
        <div class="col-md-5">
            <div class="comment-button">
                <button id="myButton" type="button" data-toggle="modal" data-target="#myModal" class="trigger-button uil-btn-secondary uil-fullwidth">
                    <span>Leave a Comment</span>
                </button>  
            </div>
        </div>
    </div>
</div>
</section>